import { setSessionInfo } from 'actions/index';
import { connect } from 'react-redux';

import JSX from '../MicrosoftAuth';

const mapDispatchToProps = (dispatch) => ({
    setSessionInfo: (sessionInfo) => dispatch(setSessionInfo(sessionInfo))
});

export default connect(null, mapDispatchToProps)(JSX);
